var exports = {
  "ZK": "ChannelFollowSuccessModal.module__hero___a1lXRn",
  "Wp": "ChannelFollowSuccessModal.module__patternImage___a1lXRn",
  "RG": "ChannelFollowSuccessModal.module__composition___a1lXRn",
  "Dr": "ChannelFollowSuccessModal.module__sourceIconWrap___a1lXRn",
  "$f": "ChannelFollowSuccessModal.module__guildIcon___a1lXRn",
  "hI": "ChannelFollowSuccessModal.module__announcementBadge___a1lXRn",
  "aw": "ChannelFollowSuccessModal.module__announcementBadgeIcon___a1lXRn",
  "UE": "ChannelFollowSuccessModal.module__arrow___a1lXRn",
  "rf": "ChannelFollowSuccessModal.module__body___a1lXRn",
  "DD": "ChannelFollowSuccessModal.module__title___a1lXRn",
  "h_": "ChannelFollowSuccessModal.module__description___a1lXRn",
};

module.exports = exports;
